import { render, staticRenderFns } from "./xAxis.vue?vue&type=template&id=4a134e68&scoped=true&"
import script from "./xAxis.vue?vue&type=script&lang=js&"
export * from "./xAxis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a134e68",
  null
  
)

export default component.exports